<ng-container *ngIf="{ trigger: trigger$ | async } as c">
  <ng-container *ngIf="state$ | async as state">
    <a *ngIf="state.cmsLinkType === cmsLinkType.ANCHOR
           || state.cmsLinkType === cmsLinkType.CONTENT_LINK
           || state.cmsLinkType === cmsLinkType.RELATED_PRODUCT_LINK
           || state.cmsLinkType === cmsLinkType.PRODUCT_LINK
           || state.cmsLinkType === cmsLinkType.ANCHOR_BUTTON
           || state.cmsLinkType === cmsLinkType.CONTENT_LINK_BUTTON
           || state.cmsLinkType === cmsLinkType.PRODUCT_LINK_BUTTON"
       [attr.aria-expanded]="ariaExpanded ?? null"
       [attr.data-color]="dataColor ?? null"
       [attr.data-cy]="state.dataCy ?? null"
       [attr.data-event-action]="dataEventAction ?? null"
       [attr.data-event-category]="dataEventCategory ?? null"
       [attr.data-event-label]="dataEventLabel ?? null"
       [attr.data-event-type]="dataEventType ?? null"
       [attr.data-filter]="dataFilter ?? null"
       [attr.data-product-code]="state.data.productCode || null"
       [attr.data-target]="dataTarget ?? null"
       [attr.data-test]="state.anchor"
       [attr.data-title]="dataTitle"
       [attr.data-footer]="dataFooter"
       [attr.data-toggle]="dataToggle ?? null"
       [attr.id]="id ?? null"
       [data-preview-id]="previewId ?? null"
       [class.resolved]="!!state.url"
       [fragment]="$any(state.anchor ?? null)"
       [ngClass]="styleClass ?? ''"
       [queryParams]="$any(queryParams ?? {})"
       [routerLink]="isCxRoute ? ({cxRoute: state.url} | cxUrl) : state.url"
       [target]="state.data.target ?? '_self'"
       [title]="state.data.tooltip ?? ''"
       (click)="onClick($event)"
       class="mb-cms-internal-link"
       mbHover
    >
      <ng-container *ngTemplateOutlet="useSlot ? contentTpl : innerHTML, context: { content: state.data.text }"></ng-container>
    </a>
    <a *ngIf="state.cmsLinkType === cmsLinkType.URL
           || state.cmsLinkType === cmsLinkType.URL_BUTTON
           || state.cmsLinkType === cmsLinkType.DOCUMENT_LINK
           || state.cmsLinkType === cmsLinkType.DOCUMENT_LINK_BUTTON
           || state.cmsLinkType === cmsLinkType.EMAIL_LINK
           || state.cmsLinkType === cmsLinkType.PHONE_LINK"
       [attr.aria-expanded]="ariaExpanded ?? null"
       [attr.data-color]="dataColor ?? null"
       [attr.data-cy]="state.dataCy"
       [attr.data-asset-name]="state.data.assetName ?? null"
       [attr.data-asset-type]="state.data.assetType ?? null"
       [attr.data-event-action]="dataEventAction ?? null"
       [attr.data-event-category]="dataEventCategory ?? null"
       [attr.data-event-label]="dataEventLabel ?? null"
       [attr.data-event-type]="dataEventType ?? null"
       [attr.data-filter]="dataFilter ?? null"
       [data-preview-id]="previewId ?? null"
       [attr.data-target]="dataTarget ?? null"
       [attr.data-toggle]="dataToggle ?? null"
       [attr.id]="id ?? null"
       [href]="state.url | safeUrl"
       [ngClass]="styleClass ?? ''"
       [target]="state.data.target ?? '_blank'"
       [title]="state.data.tooltip ?? ''"
       (click)="onClick($event)"
       class="mb-cms-external-link"
       rel="nofollow"
       mbHover
    >
      <ng-container *ngTemplateOutlet="useSlot ? contentTpl : innerHTML, context: { content: state.data.text }"></ng-container>
    </a>
    <a *ngIf="state.cmsLinkType === cmsLinkType.PRINT
           || state.cmsLinkType === cmsLinkType.SPECIAL
           || state.cmsLinkType === cmsLinkType.COOKIE_SETTINGS
           || state.cmsLinkType === cmsLinkType.CHATBOT_LINK"
       [attr.aria-expanded]="ariaExpanded ?? null"
       [attr.data-color]="dataColor ?? null"
       [attr.data-cy]="state.dataCy"
       [attr.data-event-action]="dataEventAction ?? null"
       [attr.data-event-category]="dataEventCategory ?? null"
       [attr.data-event-label]="dataEventLabel ?? null"
       [attr.data-event-type]="dataEventType ?? null"
       [attr.data-anchor]="state.anchor ?? null"
       [attr.data-filter]="dataFilter ?? null"
       [attr.data-target]="dataTarget ?? null"
       [attr.data-toggle]="dataToggle ?? null"
       [attr.id]="id ?? null"
       [class.application-print]="state.cmsLinkType === cmsLinkType.PRINT"
       [ngClass]="styleClass"
       [ngStyle]="style"
       [data-preview-id]="previewId ?? null"
       [target]="state.data.target ?? ''"
       [title]="state.data.tooltip ?? ''"
       (click)="onClick($event)"
       class="mb-cms-special-link"
       mbHover
    >
      <ng-container *ngTemplateOutlet="useSlot ? contentTpl : innerHTML, context: { content: state.data.text }"></ng-container>
    </a>
  </ng-container>
</ng-container>

<ng-template #contentTpl>
  <ng-content></ng-content>
</ng-template>

<ng-template #innerHTML
             let-content="content"
>
  <span [innerHTML]="content | safeHtml"
        mbCmsInnerHTML
  ></span>
</ng-template>
